export const withAllOption = (allLabel, options = []) => [
  { id: null, name: allLabel },
  ...options,
];

export const findFilterOption = (options, id) =>
  options.find(option => option.id === (id === undefined ? null : id)) || null;

export const translatedFilterOptions = (values, translate) =>
  values.map(value => ({ id: value, name: translate(value) }));
